import styled from "styled-components";


export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-width: 865px;
	
`

